import { ApiPlatformEnum, EcommerceCartDataSourceEnum, EcommerceShoppingListDataSourceEnum } from '@inter-ikea-kompis/enums';
/**
 * A utility for checking for shopping cart and list support.
 */
export default class ShoppingSupport {
    /**
     * Checks if shopping cart is supported.
     *
     * @param priceSettingsOrDexfPriceSettings ...
     * @returns Returns "true" if shopping cart is supported.
     */
    static hasCartSupport(priceSettingsOrDexfPriceSettings) {
        const localization = this.unwrapDexfSettingsObject(priceSettingsOrDexfPriceSettings);
        const eCommerceCartDataSource = localization?.eCommerceCartDataSource;
        const shopOnlineEnabled = localization?.shopOnlineEnabled;
        switch (eCommerceCartDataSource) {
            case EcommerceCartDataSourceEnum.disabled:
                return false;
            case EcommerceCartDataSourceEnum.default:
                return shopOnlineEnabled === true;
        }
        return true;
    }
    /**
     * Checks if shopping list is supported.
     *
     * @param priceSettingsOrDexfPriceSettings ...
     * @returns Returns "true" if shopping list is supported.
     */
    static hasListSupport(priceSettingsOrDexfPriceSettings) {
        const localization = this.unwrapDexfSettingsObject(priceSettingsOrDexfPriceSettings);
        const apiPlatform = localization?.apiPlatform;
        const eCommerceShoppingListDataSource = localization?.eCommerceShoppingListDataSource;
        const eCommerceCartDataSource = localization?.eCommerceCartDataSource;
        switch (eCommerceShoppingListDataSource) {
            case EcommerceShoppingListDataSourceEnum.shoppingListApi:
            case EcommerceShoppingListDataSourceEnum.chinaShoppingListApi:
            case EcommerceShoppingListDataSourceEnum.iows:
            case EcommerceShoppingListDataSourceEnum.mvecom:
            case EcommerceShoppingListDataSourceEnum.iksa:
                return true;
            case EcommerceShoppingListDataSourceEnum.default:
                switch (eCommerceCartDataSource) {
                    case EcommerceCartDataSourceEnum.iows:
                    case EcommerceCartDataSourceEnum.cartApi:
                        return true;
                    case EcommerceCartDataSourceEnum.default:
                        switch (apiPlatform) {
                            case ApiPlatformEnum.irw:
                                return true;
                        }
                }
        }
        return false;
    }
    /**
     * Constructs an object allowing DEXFSettings and LocalizedInformation to be passed into the function.
     *
     * @param priceSettingsOrDexfPriceSettings ...
     * @returns Returns the object with all properties required for ShoppingSupport.
     */
    static unwrapDexfSettingsObject(priceSettingsOrDexfPriceSettings) {
        if ('kompis' in priceSettingsOrDexfPriceSettings) {
            const { serviceSettings, localization } = priceSettingsOrDexfPriceSettings.kompis;
            return {
                eCommerceCartDataSource: serviceSettings.eCommerceCartDataSource,
                apiPlatform: serviceSettings.apiPlatform,
                eCommerceShoppingListDataSource: serviceSettings.eCommerceShoppingListDataSource,
                shopOnlineEnabled: localization.shopOnlineEnabled
            };
        }
        else {
            const localization = priceSettingsOrDexfPriceSettings.localization;
            return {
                eCommerceCartDataSource: localization?.eCommerceCartDataSource,
                apiPlatform: localization?.apiPlatform,
                eCommerceShoppingListDataSource: localization?.eCommerceShoppingListDataSource,
                shopOnlineEnabled: localization?.shopOnlineEnabled
            };
        }
    }
}
//# sourceMappingURL=ShoppingSupport.js.map